<template>
  <div>
    <ContentHeader :order-nav="false" />

    <div class="content-container" v-loading="loading">
      <div class="order-info-block">
        <div class="order-status">需求状态: {{ itemInfo.requirementStatusName }}</div>
        <div class="order-status-step">
          <el-steps :active="activeIndex" finish-status="success" align-center>
            <el-step v-for="status in this.showOrderStatusList" :key="status.key" :title="status.value" />
          </el-steps>
        </div>
      </div>

      <div class="order-info-block">
        <div class="block-title">产品信息</div>
        <div class="block-content">
          <el-row>
            <el-col :span="12">
              <el-row>
                <el-col class="content-title" :span="5">产品名称</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.itemName }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">产品图片</el-col>
                <el-col class="content-text content-image" :span="19">
                  <div class="item-image" v-for="img in itemDetailInfo.fileList" :key="img.fileId">
                    <img :src="getItemImageUrl(img)" />
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">需求部门</el-col>
                <el-col class="content-text" :span="19">{{ itemInfo.applyBu }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">需求人</el-col>
                <el-col class="content-text" :span="19">{{ itemInfo.applyPerson }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">材质工艺描述</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.materialDescription }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">最低开机量</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.moqProductionBatch | thousandSymbol}}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">单个地址最低起订量</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.moqDeliveryAddress | thousandSymbol}}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">订购总数量</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.ttlQty | thousandSymbol}}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">购买理由</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.reason }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">产品包装要求</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.packaging }}</el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col class="content-title" :span="5">装箱要求</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.packingRequirement | thousandSymbol}}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">使用场所</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.inOutDoorName }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">是否需要包含到点安装</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.isInstallName }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">第一批期望到货数量</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.qty1stBatch | thousandSymbol}}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">第一批期望到货日期</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.eta1stBatch | parseTime('{y}-{m}-{d}') }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">尺寸</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.dimension }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">毛重(g)</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.sweight }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">要求保修期限</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.warranty }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">物料号</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.itemNo }}</el-col>
              </el-row>
              <el-row>
                <el-col class="content-title" :span="5">备注</el-col>
                <el-col class="content-text" :span="19">{{ itemDetailInfo.remark }}</el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import ContentHeader from '@/components/content-header'
export default {
  components: {
    ContentHeader
  },
  data () {
    return {
      loading: false,
      itemInfo: {},
      itemDetailInfo: {},
      showOrderStatusList: [
        {
          key: 0,
          value: '创建'
        },
        {
          key: 100,
          value: '进行中'
        },
        {
          key: 200,
          value: '完结'
        },
        {
          key: 900,
          value: '取消'
        }
      ]
    }
  },
  computed: {
    activeIndex () {
      if (!this.itemInfo) {
        return -1
      }
      if (!this.showOrderStatusList) {
        return
      }
      for (let i = 0; i < this.showOrderStatusList.length; i++) {
        if (
          this.showOrderStatusList[i].key === this.itemInfo.requirementStatus
        ) {
          return i
        }
      }
      return -1
    }
  },
  created () {
    this.getOrderMoreInfo()
  },
  methods: {
    // 获取申请单详情
    getOrderMoreInfo () {
      this.loading = true
      this.$store
        .dispatch('getOrderMoreInfo', this.$route.params.id)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.itemInfo = res.data.resultData.purchaseRequirementDTO
            if (this.itemInfo.detailList.length) {
              this.itemDetailInfo = this.itemInfo.detailList[0]
            }
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    getItemImageUrl (img) {
      return commonUtils.getImageUrl(img.fileUri)
    }
  }
}
</script>

<style lang="scss" scoped>
.order-info-block {
  border-radius: 10px;
  background-color: $base-white;
  padding: 20px;
  margin-bottom: 20px;

  .order-status {
    color: $base-red;
  }

  .block-title {
    line-height: 32px;
  }

  .block-content {
    & > .el-row {
      border: 1px solid #e9e9e9;
      border-radius: 5px;
    }
    .el-col-12 {
      box-sizing: border-box;
      padding: $content-middle;
      border-right: 1px solid #e9e9e9;
    }

    .content-title {
      font-weight: bold;
      margin-bottom: $content-middle;
    }

    .content-text {
      padding-left: 10px;
    }

    .content-image {
      display: flex;
      .item-image {
        width: 65px;
        height: 65px;
        border: 1px solid $base-grey;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        margin-right: 10px;
        margin-bottom: 10px;
        img {
          max-width: 90%;
          max-height: 90%;
        }
      }
    }
  }
}
.order-status-step {
  border-top: solid 1px $base-grey3;
  border-bottom: solid 1px $base-grey3;
  margin-top: 10px;
  padding: 30px;

  ::v-deep .el-step__head.is-process {
    color: $base-red;
    border-color: $base-red;
  }
  ::v-deep .el-step__title.is-process {
    color: $base-red;
  }
}
</style>
